import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPCertLogicViewLocs =
       'SPCertLogicViewLabelPath' | 'SPCertLogicViewContentActive';

export const spCertLogicViewLocs: LocDefs<SPCertLogicViewLocs> = {
    SPCertLogicViewLabelPath: {
        defaultValue: 'Path',
        description: 'Label for the path selector',
        displayPath: `Cert Logic View|Path`,
        displayType: 'Label',
        feature: HubFeature.Credential,
        portal: 'SP',
    },
    SPCertLogicViewContentActive: {
        defaultValue: 'Active',
        description: 'Content for the active path',
        displayPath: `Cert Logic View|Active`,
        displayType: 'Content',
        feature: HubFeature.Credential,
        portal: 'SP',
    },
};

export type SPCertLogicViewLocKeys = LocMap<SPCertLogicViewLocs>;
export const spCertLogicViewLocKeys: SPCertLogicViewLocKeys =
    MapLocKeys<SPCertLogicViewLocs>(spCertLogicViewLocs);


export type CPCertLogicViewLocs =
    'CPCertLogicViewLabelPath' | 'CPCertLogicViewContentActive';

export const cpCertLogicViewLocs: LocDefs<CPCertLogicViewLocs> = {
 CPCertLogicViewLabelPath: {
     defaultValue: 'Path',
     description: 'Label for the path selector',
     displayPath: `Cert Logic View|Path`,
     displayType: 'Label',
     feature: HubFeature.Credential,
     portal: 'CP',
 },
 CPCertLogicViewContentActive: {
     defaultValue: 'Active',
     description: 'Content for the active path',
     displayPath: `Cert Logic View|Active`,
     displayType: 'Content',
     feature: HubFeature.Credential,
     portal: 'CP',
 },
};

export type CPCertLogicViewLocKeys = LocMap<CPCertLogicViewLocs>;
export const cpCertLogicViewLocKeys: CPCertLogicViewLocKeys =
 MapLocKeys<CPCertLogicViewLocs>(cpCertLogicViewLocs);